import React from 'react'

export const Banner = () => {
  return (
    <div className="d-flex justify-content-center" style={{ paddingBottom: '128px' }}>
      <div
        className="row w-100 d-flex justify-content-end px-0 pb-0"
        style={{
          backgroundImage: 'url(/static/graphics/homepage_banner.svg)',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          backgroundPosition: 'center center',
          width: '100%',
          minHeight: '600px'
        }}
      >
        <div className="col-12 col-md-6 d-flex align-items-end px-0">
          <p className="fw-semibold homepage-banner-text text-end pb-0 pb-md-5 pb-xl-0 unselectable">
            <span className="position-relative" style={{ top: '0.45em' }}>
              Arpeggi
            </span>
            <br />
            <span className="position-relative">Genesis</span>
          </p>
        </div>
        <div className="col-12 col-md-6 d-flex align-items-end justify-content-end">
          <a
            href={'/studio'}
            className="underline fw-semibold italic studio-button"
            style={{ backgroundColor: 'var(--homepage-background)' }}
          >
            <h2>Explore the studio</h2>
          </a>
        </div>

        {/* <img className="" src="/static/graphics/homepage_banner.svg" style={{ width: '100%' }} /> */}
      </div>
    </div>
  )
}
